import React, { useCallback } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import Button from 'reactstrap/lib/Button';
import { SUBMIT_CTA, UPDATE_CTA } from 'site-modules/shared/constants/write-review/write-review';

import './submit-button.scss';

export function SubmitButton({
  isLoading = false,
  onClick,
  validate = null,
  isUpdateForm = false,
  dataTrackingId = null,
}) {
  const onButtonClick = useCallback(
    event => {
      event.preventDefault();

      if (validate && !validate()) {
        return;
      }

      onClick(event);
    },
    [onClick, validate]
  );

  return (
    <Button
      type="submit"
      color="primary-b"
      size="lg"
      className={classnames('btn-step-submit text-capitalize mb-1_5 mt-0_25', {
        'spinner-active': isLoading,
      })}
      onClick={onButtonClick}
      disabled={isLoading}
      data-tracking-id={dataTrackingId}
    >
      <i className="spinner icon-spinner8 me-0_25" aria-hidden />
      <span className="fw-normal">{isUpdateForm ? UPDATE_CTA : SUBMIT_CTA}</span>
    </Button>
  );
}

SubmitButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  dataTrackingId: PropTypes.string,
  isLoading: PropTypes.bool,
  isUpdateForm: PropTypes.bool,
  validate: PropTypes.func,
};
